import React from 'react'
import { BlockComponentProps } from '../../types'
import RichTextView from '../../richText/RichTextView'
import { isRichTextEmpty } from '../../richText/emptyContent'

/**
 * Read-only Text block. Editing is provided by the builder (TextBlockEditor),
 * which needs MI6's editor components and so lives outside src/doclets.
 * Empty text is left out of the rendered page.
 */
const TextBlock = ({ block }: BlockComponentProps<'text'>) => {
  if (isRichTextEmpty(block.props.body)) return null
  return <RichTextView content={block.props.body} />
}

export default TextBlock
